module.exports = __webpack_public_path__ + "static/Number 108-819264bee93558d9f90429be05bc37b9.jpg";